module.exports = __webpack_public_path__ + "img/home-background.dbbd07d4.png";